import React, { useEffect, useState, useRef, createContext } from 'react'
import {
  createUserWithEmailAndPassword, onAuthStateChanged,
  signInWithEmailAndPassword, signOut, sendPasswordResetEmail
} from 'firebase/auth';
import { auth, db } from '../Firebase/firebase';
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import validator from 'validator';


export const ContextUser = createContext();

export const UserContext = (props) => {

  const [userStatus, setUserStatus] = useState({});
  const [userRole, setUserRole] = useState({});
  const [loginStatus, setLoginStatus] = useState(false);
  const [status, setStatus] = useState("");
  const [alert, setAlert] = useState("");

  const [open, setOpen] = useState(false);

   const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  

  const Name = useRef(null);
  const Email = useRef(null);
  const Password = useRef(null);
  const Role = useRef(null);

  const loginEmail = useRef(null);
  const loginPassword = useRef(null);



  const AlertBox = useAlert();

  // onAuthStateChanged(auth, (currentUser) => {
  //     setUser(currentUser);
  //   });

  //   const EmailID = Email.current.value;
  //   const PasswordReg = Password.current.value;
  //   const NameReg = Name.current.value;
  //   const RoleReg = Role.current.value;


  const register = async () => {

    const EmailID = Email.current.value;
    const PasswordReg = Password.current.value;
    const NameReg = Name.current.value;
    const RoleReg = Role.current.value;

    try {

      const res = await createUserWithEmailAndPassword(auth, EmailID, PasswordReg)
      const user = res.user;

      await setDoc(doc(db, "users", user.uid), {
        // UserUid: user.uid,
        FullName: NameReg,
        // Email: EmailID,
        // Password: PasswordReg,
        Role: RoleReg,
        createdAt: new Date(),
      });
      handleClick();
      setStatus("Register Successfull !!!");
      setAlert("success");

      // console.log("Document written with ID: ", userRef.id);

    }
    catch (err) {
      handleClick();
      console.log("Email Already Exist!!!");
      setStatus("Email Already Exist !!!");
      setAlert("error")

    }


  }

  const login = async () => {
    const LoginEmailID = loginEmail.current.value;
    const LoginPassword = loginPassword.current.value;
    try {
      const res = await signInWithEmailAndPassword(
        auth,
        LoginEmailID,
        LoginPassword
      );
      const user = res.user;
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);
      handleClick();
      setLoginStatus(true);
      setStatus("Login Successfull !!!");
      setAlert("success");
      if (docSnap.exists()) {
        setUserRole(docSnap.data().Role);
        setUserStatus(docSnap.data().FullName);

      }

      else {
        // doc.data() will be undefined in this case
      }


    } catch (error) {
      handleClick();
      setLoginStatus(false);
      setStatus("Invalid Credentials !!!");
      setAlert("error");
    }
  }

  const TriggerYesBtn = async () => {
    const LoginEmailID = loginEmail.current.value;
    try {
      await sendPasswordResetEmail(auth, LoginEmailID);
      AlertBox.show("The Reset Password Link is Sent to Your Email !!!");
    }
    catch (err) {
      AlertBox.error("This User Is Not Registered !!!!");
    }

  }

  const ResetEmail = () => {
    
    const LoginEmailID = loginEmail.current.value;

    if (LoginEmailID !== "" && validator.isEmail(LoginEmailID)) {

      confirmAlert({
        title: "Are You Sure ?",
        message: "Are You Sure You Want To Reset Your Password ?",
        buttons: [
          {
            label: "Yes",
            onClick: () => TriggerYesBtn()
          },
          {
            label: "No"
          }
        ]
      });
    }
    else {
      // await sendPasswordResetEmail(auth, LoginEmailID);
      AlertBox.show("Please Enter Valid Email Address !!!");
    }

  }


  const logout = async () => {

    await signOut(auth);
  };



  return (

    <ContextUser.Provider

      value={{
        Name,
        Email,
        Password,
        Role,
        loginEmail,
        loginPassword,
        status,
        alert,
        loginStatus,
        userStatus,
        userRole,
        register,
        open,
        handleClose,
        login,
        logout,
        ResetEmail,
      }}

    >

      {props.children}

    </ContextUser.Provider>

  )
}